import type {LibraryEntry, StudySession} from "@/shared/types";

/**
 * Metadata fields used for local synchronization and persistence.
 * These should never be sent to the remote AT Protocol repository.
 */
export interface SyncMetadata {
  uri?: string;
  cid?: string;
  synced?: boolean;
  isDeleted?: 0 | 1;
}

/**
 * Strips internal synchronization fields from a library entry object.
 */
export function stripLibraryEntryMetadata<T extends Partial<LibraryEntry>>(
  entry: T & SyncMetadata,
): T {
  const {uri, cid, synced, isDeleted, ...clean} = entry;
  return clean as T;
}

/**
 * Strips internal synchronization fields from a study session object.
 */
export function stripStudySessionMetadata<T extends Partial<StudySession>>(
  session: T & SyncMetadata,
): T {
  const {uri, cid, synced, isDeleted, ...clean} = session;
  return clean as T;
}
